import React from "react";

const Slider = ({ value, onInput, min = 0, max = 100, step = 0.1 }) => {
    return (
        <input
            type="range"
            min={min}
            max={max || 0}
            step={step}
            value={value}
            onInput={onInput}
            className="w-full accent-sil-red-500 bg-gray-200 h-2 rounded-lg cursor-pointer"
            style={{
                '--tw-thumb-color': '#FFD700', // Yellow thumb (Hex code for gold)
            }}
        />
    );
}

export default Slider;